import { Grid, Tooltip, withStyles } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import { ClassNameMap } from "@material-ui/styles";
import { lang } from "i18nLang";

const styles = (theme) => ({
  icon: {
    width: 12,
    height: 12,
    marginLeft: 5,
    color: theme.palette.gray[600],
  },
});

/** Componente da célula título da coluna 'Material empregado'. */
const MaterialUsedHeadCell = withStyles(styles)(
  ({ classes }: { classes: ClassNameMap<"icon"> }) => (
    <Grid container alignItems="center">
      <span>{lang("fields.materialUsed")}</span>
      <Tooltip title={lang("billing.materialUsedTooltip")}>
        <InfoIcon className={classes.icon} />
      </Tooltip>
    </Grid>
  )
);

export default MaterialUsedHeadCell;
